import { Badge, Flex, Text } from '@chakra-ui/react';
import { Checkbox } from '@morressier/alembic';
import { ISearchQueryItems } from 'src/api/queries';
import { APPLICATION_NAME } from 'src/constants';
import { isJournalManagerUser } from 'src/utils/reviews';

interface Props {
  item: ISearchQueryItems;
  isSelected: boolean;
  onChange: () => void;
  disabled: boolean;
}

const ReviewerInformationHeader = ({ item, isSelected, onChange, disabled }: Props) => {
  const displayName =
    item.properties.find(property => property.propertyName === 'ReviewerDisplayname')
      ?.propertyValueString?.[0] ?? '-';

  const isApplicationUser = isJournalManagerUser(item);

  const isBoardMember =
    item.properties.some(property => property.propertyName === 'boardMember') &&
    item.properties.find(property => property.propertyName === 'boardMember')?.propertyBoolean === true;

  return (
    <Flex flexDirection="row" gap={2} alignItems="center">
      <Checkbox
        ariaLabel="select-reviewer"
        id={item.classId}
        name="reviewer-info"
        isChecked={isSelected}
        onChange={onChange}
        disabled={disabled}
      >
        <Text textStyle="headingItem">{displayName}</Text>
      </Checkbox>
      {isApplicationUser ? <Badge variant="solid"><Text textStyle={'textContext'}>{APPLICATION_NAME} User</Text></Badge> : null}
      {isBoardMember ? <Badge variant="solid"><Text textStyle={'textContext'}>Board Member</Text></Badge> : null}
    </Flex>
  );
};

export default ReviewerInformationHeader;
